import type { ReactNode } from 'react';
import styled from 'styled-components';

import { color, shadow, breakpoint } from '@ovpn/ui/tokens';

export const Container = styled.div<{ className?: string; children: ReactNode }>`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 576px;
    padding: 32px;

    word-break: break-word;

    background-color: ${color.neutral.white};
    border: 1px solid ${color.neutral.bgHover};
    border-radius: 8px;
    box-shadow: ${shadow.sm};

    @media (max-width: ${breakpoint.sm}px) {
        padding: 0;

        border: none;
        box-shadow: none;
    }
`;

export const Header = styled.div`
    display: flex;
    gap: 16px;
    justify-content: space-between;
    margin-bottom: 32px;
`;

export const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;
